import { Text } from '@chakra-ui/react';
import { SOCIAL_PLATFORMS } from 'ui-components';
import {
  MONTH_NAME_DAY_YEAR_FORMAT,
  SOCIAL_PLATFORMS_CONNECTION_STATUS,
} from '~/constants';
import { CreatorBenchmarks } from '~/types';
import { formatDate } from '~/utils';

import { PLATFORM_UPDATED } from './LastUpdatedPlatform.constants';

interface Props {
  platformConnection: SOCIAL_PLATFORMS_CONNECTION_STATUS;
  creatorBenchmarks?: CreatorBenchmarks;
  platform?: Exclude<SOCIAL_PLATFORMS, 'snapchat'>;
  insightsLastUpdatedAt?: string;
}

export const LastUpdatedPlatform: React.FC<Props> = ({
  platformConnection,
  creatorBenchmarks,
  platform,
  insightsLastUpdatedAt,
}) => {
  let lastUpdated = insightsLastUpdatedAt
    ? formatDate(insightsLastUpdatedAt, MONTH_NAME_DAY_YEAR_FORMAT)
    : '';

  if (creatorBenchmarks && platform) {
    const platformKey = PLATFORM_UPDATED[platform] as keyof CreatorBenchmarks;
    const platformUpdatedDate = creatorBenchmarks[platformKey];
    if (platformUpdatedDate) {
      lastUpdated = formatDate(platformUpdatedDate, MONTH_NAME_DAY_YEAR_FORMAT);
    }
  }

  return platformConnection ===
    SOCIAL_PLATFORMS_CONNECTION_STATUS.connectionExpired ? (
    <Text color={'primary.400'} fontSize="sm" fontWeight={400} marginTop={2}>
      {lastUpdated}
    </Text>
  ) : null;
};
